import { render, staticRenderFns } from "./WhiteIpView.vue?vue&type=template&id=1004b5a0&"
import script from "./WhiteIpView.vue?vue&type=script&lang=js&"
export * from "./WhiteIpView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports